module.exports = __webpack_public_path__ + "LGFacad_3.2c897097.png";